import {useState} from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { useForm, Controller } from 'react-hook-form';


// components
import DatePicker from 'components/shared/DatePicker';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import LoadingButton from 'components/shared/LoadingButton';
import Typography from 'components/shared/Typography';
import Input from 'components/shared/Input';


// constants
import { SPACING_THIRD,SPACING } from 'constants/spacing';

//assets
import leftImage from 'assets/images/customer-login.png';
import signupImage from 'assets/images/customer/signup.png'

//hooks
import { useSignup } from 'hooks/auth';

//libs
import { getSignupTokenCookie, removeSignupTokenCookie, setRefreshTokenCookie } from 'lib/Storage';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // minHeight: '100vh',
    minHeight:"fit-content",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    
    width: '100%',
    // minHeight: '100vh',
    minHeight:"fit-content",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    marginTop: -theme.spacing(SPACING),
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    marginTop: 35,
    fontSize: theme.typography.pxToRem(25),
    height:"75%",
    [theme.breakpoints.down('xs')]: {
      // marginTop: ""
    },
    '&:disabled':{
      color: '#959595'
    }
    
  },
  wholepage:{
    width:"100vw",
    height:"100vh",
    backgroundColor:"#e5e5e5",
  },
  container:{
    padding:"5%",
    
    [theme.breakpoints.down('xs')]: {
     marginRight:0
    },
  },
  mainContainer:{
    backgroundColor:"#f5f5f5",
    // borderRadius:"10px",
    position:'relative',
    top:"15%",
    padding:"0px",
    [theme.breakpoints.down('xs')]: {
      backgroundColor:"#e5e5e5",
      top:"0%",
    },
  }
}));

/**
 * @component CompleteProfile
 */
function CompleteProfile() {
  const classes = useStyles();
  const history = useHistory();

  const { mutate, isLoading } = useSignup();

  const [description, setDescription] = useState('');
  const [address, setAddress] = useState('');
  const [birthDate, setBirthDate] = useState(null);


  const onSubmit = (e) => {
    let signupToken = getSignupTokenCookie()
    if(!signupToken){
      history.push("/auth/otp")
    }
    // e.preventDefault();
    const newCustomer = {
      signupToken,
      fullname:e.fullname,
      referralCode:e.referralCode,
      birthDate,
      address,
      description,
    };
    mutate(newCustomer, {
      onSuccess: (data) => {
        console.log("injast!",data)
        if (data?.status === 'OK') {
          removeSignupTokenCookie()
          setRefreshTokenCookie(data?.refreshToken)
          history.push('/');
        }
      },
    });
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      phoneNumber: '',
    },
  });

  return (
    <div className={classes.wholepage}>
    <Container maxWidth="md" className={classes.mainContainer}>
      <Grid container spacing={0}>
        {/* <div className={classes.root}> */}
        <Grid item xs={12} md={6} className={classes.root}>
            <form noValidate onSubmit={handleSubmit(onSubmit)} className={classes.form}>
              <Grid container spacing={SPACING_THIRD} className={classes.container}>
                <Grid item xs={12}>
                  <Typography align="center" variant="h2">
                    به قاصدک خوش آمدید!
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                <Controller
                  name="fullname"
                  rules={{ required: true }}
                  control={control}
                  render={({ field }) => (
                    <Input
                      label="نام و نام خانوادگی*"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      helperText={
                        errors?.fullname?.type === 'required' && (
                          <Typography variant="body2" component="span" color="error">
                            وارد کردن این فیلد ضرروی است
                          </Typography>
                        )
                      }
                      {...field}
                    />
                  )}
                />
              </Grid>
              

              <Grid item xs={12} md={6}>
                <Controller
                  name="referralCode"
                  control={control}
                  render={({ field }) => (
                    <Input
                      label="کد معرف"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      {...field}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <DatePicker
                  label="تاریخ تولد"
                  placeholder="--انتخاب تاریخ--"
                  okLabel="تأیید"
                  value={birthDate}
                  onChange={(val) => setBirthDate(new Date(val._d).getTime())}
                  cancelLabel="لغو"
                  loading={isLoading}
                  clearLabel="پاک کردن"
                  labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                  TextFieldComponent={(props) => (
                    <Input
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      {...props}
                      variant="outlined"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  label="آدرس"
                  fullWidth
                  value={address}
                  onChange={(value) => setAddress(value)}
                  multiline
                  rows={3}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  label="درباره من"
                  placeholder="اطلاعاتی در مورد شما که همکاران ما باید در مورد شما بدانند، مثل بیماری های زمینه ای و حساسیت ها و موارد مهم دیگر، را در این قسمت بنویسید."
                  fullWidth
                  value={description}
                  onChange={(value) => setDescription(value)}
                  multiline
                  rows={5}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
             
                <Grid item xs={12} className={classes.buttonWraper}>
                  <LoadingButton
                    className={classes.largeLabel}
                    type="submit"
                    // size="small"
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled={errors?.phoneNumber}
                    loading={isLoading}
                  >
                      ثبت اطلاعات
                  </LoadingButton>
                </Grid>
              </Grid>
            </form>
          
        </Grid>

        <Grid item xs={12} md={6} className={classes.leftPanel}>
          {/* <div className={classes.monkey}> */}
          <img src={signupImage} alt="signup" height={'80%'} />
        </Grid>
        {/* </div> */}
      </Grid>
    </Container>
    </div>
  );
}

export default CompleteProfile;
